import { TThunkAction } from '../../types/redux/thunk';
import { getLkType } from '../../services/getLkType';
import { setLkType } from './actions';

export function getLkTypeAction(): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, { httpApi, logger }) => {
    const { lkType } = await getLkType(httpApi, logger);
    dispatch(setLkType(lkType));
  };
}
